import * as types from "./deca.actionTypes";

export default {
  save: (data) => ({
    type: types.DECASOLICITACAO_POST,
    payload: data,
  }),
  getById: (id) => ({
    type: types.DECASOLICITACAO_GET,
    payload: id,
  }),
  setDecaSolicitacao: (data) => ({
    type: types.DECASOLICITACAO_SET,
    payload: data,
  }),
  loadComboGrupo: (data) => ({
    type: types.DECASOLICITACAO_LOADGRUPO,
    payload: data,
  }),
  setComboGrupo: (data) => ({
    type: types.DECASOLICITACAO_SETCOMBOGRUPO,
    payload: data,
  }),
  update: (data) => ({
    type: types.DECASOLICITACAO_PUT,
    payload: data,
  }),
  remove: (id) => ({
    type: types.DECASOLICITACAO_DELETE,
    payload: id,
  }),
  validarTipoEmpresa: (data) => ({
    type: types.DECASOLICITACAO_VALIDAR_TIPO_EMPRESA,
    payload: data,
  }),
  getParametro: () => ({
    type: types.PARAMETRO_GET,
  }),
  setParametro: (data) => ({
    type: types.PARAMETRO_SET,
    payload: data,
  }),
  setSolicitante: (data) => ({
    type: types.SOLICITANTE_SET,
    payload: data,
  }),
  getDadosSolicitacao: (data) => ({
    type: types.SOLICITACAO_GET,
    payload: data,
  }),

  setReducerTypeDeca: (data) => ({
    type: types.SET_REDUCER_TYPEDECA,
    payload: data,
  }),
  setReducarLoadDeca: (data) => ({
    type: types.SET_REDUCER_LOADDECA,
    payload: data,
  }),
  setSomenteEnderecoSede: (data) => ({
    type: types.SET_SOMENTE_ENDERECO_SEDE,
    payload: data,
  }),
  getManual: (data) => ({
    type: types.DECASOLICITACAO_GETMANUAL,
    payload: data,
  }),
  setDisableAllSolicitacao: (data) => ({
    type: types.SET_DISABLE_ALL_SOLICITACAO,
    payload: data,
  }),
};
